"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckbookConfigOutSerializer = void 0;
exports.CheckbookConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=checkbookConfigOut.js.map